(function () {
  'use strict';


  /* ==========================================
     GENERAL HELPERS
     ========================================== */

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function isFrenchLocale(section) {
    return String(
      section && section.dataset
        ? section.dataset.locale || ''
        : ''
    )
      .toLowerCase()
      .startsWith('fr');
  }


  function formatScore(value) {
    const number = Number(value) || 0;

    if (
      Math.abs(
        number - Math.round(number)
      ) < 0.05
    ) {
      return String(
        Math.round(number)
      );
    }

    return number.toFixed(1);
  }



  /* ==========================================
     PRODUCT DATA
     ========================================== */

  function getIpadProductFeed(section) {
    if (!section) {
      return [];
    }


    const sectionId =
      section.dataset.sectionId;


    const script =
      section.querySelector(
        '[data-ipad-products="' +
          sectionId +
          '"]'
      ) ||
      section.querySelector(
        '[data-ipad-products]'
      );


    if (!script) {
      console.warn(
        '[Lab9 iPad keuzehulp] Productfeed niet gevonden.'
      );

      return [];
    }


    try {
      const products =
        JSON.parse(
          script.textContent
        );


      if (!Array.isArray(products)) {
        throw new Error(
          'Productfeed is geen array.'
        );
      }


      return products;

    } catch (error) {

      console.error(
        '[Lab9 iPad keuzehulp] Productfeed kon niet worden gelezen:',
        error
      );


      return [];
    }
  }



  function getIpadChoiceCopy(section) {
    if (!section) {
      return null;
    }


    const sectionId =
      section.dataset.sectionId;


    const script =
      section.querySelector(
        '[data-ipad-choice-copy="' +
          sectionId +
          '"]'
      );


    if (!script) {
      console.warn(
        '[Lab9 iPad keuzehulp] Wizardcopy niet gevonden.'
      );

      return null;
    }


    try {
      return JSON.parse(
        script.textContent
      );

    } catch (error) {

      console.error(
        '[Lab9 iPad keuzehulp] Wizardcopy kon niet worden gelezen:',
        error
      );


      return null;
    }
  }



  function getGenerationLabel(baseHandle) {
    if (!baseHandle) {
      return '';
    }


    const normalized =
      baseHandle.toLowerCase();


    const mMatch =
      normalized.match(
        /-(m\d+)$/
      );


    if (mMatch) {
      return mMatch[1].toUpperCase();
    }


    const aProMatch =
      normalized.match(
        /-(a\d+)-pro$/
      );


    if (aProMatch) {
      return (
        aProMatch[1].toUpperCase() +
        ' Pro'
      );
    }


    const aMatch =
      normalized.match(
        /-(a\d+)$/
      );


    if (aMatch) {
      return aMatch[1].toUpperCase();
    }


    return '';
  }



  function getGenerationNumber(
    generationLabel
  ) {
    const match =
      String(
        generationLabel || ''
      ).match(
        /[MA](\d+)/i
      );


    return match
      ? Number(match[1])
      : 0;
  }



  function getModelName(model) {
    const generation =
      model.generationLabel;


    switch (model.familyHandle) {

      case 'ipad-mini':
        return generation
          ? 'iPad mini ' + generation
          : 'iPad mini';


      case 'ipad-air':
        return [
          model.sizeLabel,
          'iPad Air',
          generation
        ]
          .filter(Boolean)
          .join(' ');


      case 'ipad-pro':
        return [
          model.sizeLabel,
          'iPad Pro',
          generation
        ]
          .filter(Boolean)
          .join(' ');


      case 'ipad':
      default:
        return generation
          ? 'iPad ' + generation
          : 'iPad';
    }
  }



  function groupProductsIntoModels(products) {
    const groups =
      new Map();


    products.forEach(
      function (product) {

        if (!product.baseHandle) {
          return;
        }


        if (
          !groups.has(
            product.baseHandle
          )
        ) {

          groups.set(
            product.baseHandle,
            {
              family:
                product.family || '',

              familyHandle:
                product.familyHandle || '',

              familyUrl:
                product.familyUrl || '',

              baseHandle:
                product.baseHandle,

              baseTitle:
                product.baseTitle || '',

              sizeCategory:
                product.sizeCategory ||
                'standard',

              sizeLabel:
                product.sizeLabel || '',

              configurations: []
            }
          );
        }


        groups
          .get(product.baseHandle)
          .configurations
          .push(product);
      }
    );


    const models =
      Array.from(
        groups.values()
      ).map(
        function (model) {

          const configurations =
            model.configurations;


          const prices =
            configurations
              .map(
                function (product) {
                  return (
                    Number(
                      product.price
                    ) || 0
                  );
                }
              )
              .filter(
                function (price) {
                  return price > 0;
                }
              );


          const minPrice =
            prices.length
              ? Math.min.apply(
                  null,
                  prices
                )
              : 0;


          const cheapestProduct =
            configurations.find(
              function (product) {
                return (
                  Number(
                    product.price
                  ) === minPrice
                );
              }
            ) ||
            configurations[0];


          const imageProduct =
            configurations.find(
              function (product) {
                return Boolean(
                  product.image
                );
              }
            ) ||
            cheapestProduct;


          model.minPrice =
            minPrice;


          model.compareAtPrice =
            cheapestProduct
              ? Number(
                  cheapestProduct.compareAtPrice
                ) || 0
              : 0;


          model.image =
            imageProduct
              ? imageProduct.image
              : '';


          model.representativeHandle =
            cheapestProduct
              ? cheapestProduct.handle
              : '';


          model.configurationCount =
            configurations.length;


          model.generationLabel =
            getGenerationLabel(
              model.baseHandle
            );


          model.generationNumber =
            getGenerationNumber(
              model.generationLabel
            );


          model.name =
            getModelName(
              model
            );


          return model;
        }
      );


    models.sort(
      function (a, b) {
        return (
          a.minPrice -
          b.minPrice
        );
      }
    );


    return models;
  }



  /* ==========================================
     TEMPORARY PRODUCT DEBUG
     ========================================== */

  function renderProductDebug(
    section,
    models
  ) {
    if (!section) {
      return;
    }


    const oldDebug =
      section.querySelector(
        '[data-ipad-js-model-debug]'
      );


    if (oldDebug) {
      oldDebug.remove();
    }


    const debug =
      document.createElement(
        'div'
      );


    debug.setAttribute(
      'data-ipad-js-model-debug',
      ''
    );


    debug.innerHTML = `
      <div class="page-width">

        <h2>
          JavaScript modelgroepen
        </h2>

        <table>

          <thead>
            <tr>
              <th>Naam</th>
              <th>Familie</th>
              <th>Formaat</th>
              <th>Generatie</th>
              <th>Configuraties</th>
              <th>Vanafprijs</th>
              <th>Afbeelding</th>
            </tr>
          </thead>

          <tbody>

            ${models
              .map(
                function (model) {
                  return `
                    <tr>

                      <td>
                        ${escapeHtml(
                          model.name
                        )}
                      </td>

                      <td>
                        ${escapeHtml(
                          model.familyHandle
                        )}
                      </td>

                      <td>
                        ${escapeHtml(
                          model.sizeCategory
                        )}
                      </td>

                      <td>
                        ${escapeHtml(
                          model.generationLabel
                        )}
                      </td>

                      <td>
                        ${model.configurationCount}
                      </td>

                      <td>
                        € ${(
                          model.minPrice /
                          100
                        ).toLocaleString(
                          'nl-BE',
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }
                        )}
                      </td>

                      <td>
                        ${
                          model.image
                            ? 'Ja'
                            : 'Nee'
                        }
                      </td>

                    </tr>
                  `;
                }
              )
              .join('')}

          </tbody>

        </table>

      </div>
    `;


    section.appendChild(
      debug
    );
  }



  /* ==========================================
     SCROLL
     ========================================== */

  function getStickyHeaderOffset() {
    const candidates =
      document.querySelectorAll(
        'header, sticky-header, #shopify-section-header, .header-wrapper, .shopify-section-header-sticky'
      );


    let activeOffset = 0;
    let fallbackHeight = 0;


    candidates.forEach(
      function (element) {

        const styles =
          window.getComputedStyle(
            element
          );


        const rect =
          element.getBoundingClientRect();


        const stickyOrFixed =
          styles.position === 'sticky' ||
          styles.position === 'fixed';


        if (!stickyOrFixed) {
          return;
        }


        if (rect.height > 0) {

          fallbackHeight =
            Math.max(
              fallbackHeight,
              rect.height
            );
        }


        const visibleAtTop =
          rect.bottom > 0 &&
          rect.top <= 5;


        if (visibleAtTop) {

          activeOffset =
            Math.max(
              activeOffset,
              rect.bottom
            );
        }

      }
    );


    return Math.max(
      0,
      activeOffset ||
        fallbackHeight
    );
  }



  function scrollIpadChoiceToTop(
    context
  ) {
    if (
      !context ||
      !context.section
    ) {
      return;
    }


    const scrollTarget =
      context.section.querySelector(
        '.lab9-ipad-choice-helper__wizard'
      );


    if (!scrollTarget) {
      return;
    }


    const extraGap =
      window.innerWidth <= 749
        ? 24
        : 32;


    window.setTimeout(
      function () {

        const absoluteTop =
          scrollTarget
            .getBoundingClientRect()
            .top +
          window.pageYOffset;


        const headerOffset =
          getStickyHeaderOffset();


        const targetTop =
          absoluteTop -
          headerOffset -
          extraGap;


        window.scrollTo({
          top: Math.max(
            0,
            targetTop
          ),
          behavior: 'smooth'
        });

      },
      80
    );
  }



  /* ==========================================
     QUESTION FLOW
     ========================================== */

  function shouldShowAccessoriesQuestion(
    state
  ) {
    const relevantUseCases = [
      'study',
      'drawing',
      'creative',
      'work',
      'pro'
    ];


    return relevantUseCases.includes(
      state.answers.use
    );
  }



  function getQuestionKeys(
    state
  ) {
    const questionKeys = [
      'use',
      'size'
    ];


    if (
      shouldShowAccessoriesQuestion(
        state
      )
    ) {
      questionKeys.push(
        'accessories'
      );
    }


    questionKeys.push(
      'intensity',
      'priority'
    );


    return questionKeys;
  }



  function cleanConditionalAnswers(
    state
  ) {
    if (
      !shouldShowAccessoriesQuestion(
        state
      )
    ) {
      state.answers.accessories = '';
    }
  }



  /* ==========================================
     SCORING - FAMILY / USE
     ========================================== */

  function getUseScore(
    model,
    use
  ) {
    const scores = {

      ipad: {
        daily: 8,
        study: 7,
        family: 10,
        reading: 4,
        drawing: 2,
        creative: 0,
        work: 4,
        pro: -4
      },


      'ipad-mini': {
        daily: 5,
        study: 5,
        family: 5,
        reading: 10,
        drawing: 6,
        creative: 3,
        work: -3,
        pro: -2
      },


      'ipad-air': {
        daily: 5,
        study: 8,
        family: 3,
        reading: 3,
        drawing: 10,
        creative: 9,
        work: 10,
        pro: 7
      },


      'ipad-pro': {
        daily: 0,
        study: 3,
        family: -4,
        reading: -2,
        drawing: 9,
        creative: 10,
        work: 9,
        pro: 12
      }

    };


    return (
      scores[
        model.familyHandle
      ]?.[use] || 0
    );
  }



  /* ==========================================
     SCORING - SIZE
     ========================================== */

  function getSizeScore(
    model,
    size
  ) {
    if (
      !size ||
      size === 'any'
    ) {
      return 0;
    }


    const scores = {

      compact: {
        compact: 14,
        standard: -5,
        large: -12
      },


      standard: {
        compact: -2,
        standard: 10,
        large: 1
      },


      large: {
        compact: -12,
        standard: -4,
        large: 14
      }

    };


    return (
      scores[size]?.[
        model.sizeCategory
      ] || 0
    );
  }



  /* ==========================================
     SCORING - ACCESSORIES
     ========================================== */

  function getAccessoriesScore(
    model,
    accessories
  ) {
    if (!accessories) {
      return 0;
    }


    const scores = {

      pencil: {
        ipad: 1,
        'ipad-mini': 6,
        'ipad-air': 10,
        'ipad-pro': 10
      },


      keyboard: {
        ipad: 5,
        'ipad-mini': -8,
        'ipad-air': 10,
        'ipad-pro': 9
      },


      both: {
        ipad: 2,
        'ipad-mini': -6,
        'ipad-air': 11,
        'ipad-pro': 10
      },


      none: {
        ipad: 2,
        'ipad-mini': 2,
        'ipad-air': 1,
        'ipad-pro': 0
      }

    };


    return (
      scores[accessories]?.[
        model.familyHandle
      ] || 0
    );
  }



  /* ==========================================
     SCORING - INTENSITY
     ========================================== */

  function getIntensityScore(
    model,
    intensity
  ) {
    const scores = {

      light: {
        ipad: 8,
        'ipad-mini': 6,
        'ipad-air': 4,
        'ipad-pro': -2
      },


      regular: {
        ipad: 1,
        'ipad-mini': 4,
        'ipad-air': 10,
        'ipad-pro': 8
      },


      pro: {
        ipad: -6,
        'ipad-mini': -3,
        'ipad-air': 7,
        'ipad-pro': 12
      }

    };


    return (
      scores[intensity]?.[
        model.familyHandle
      ] || 0
    );
  }



  /* ==========================================
     SCORING - HARD MISMATCHES
     ========================================== */

  function getHardPenalty(
    model,
    answers
  ) {
    let penalty = 0;


    if (
      answers.size === 'compact' &&
      model.sizeCategory === 'large'
    ) {
      penalty -= 8;
    }


    if (
      answers.size === 'large' &&
      model.sizeCategory === 'compact'
    ) {
      penalty -= 8;
    }


    if (
      (
        answers.accessories === 'keyboard' ||
        answers.accessories === 'both'
      ) &&
      model.familyHandle === 'ipad-mini'
    ) {
      penalty -= 7;
    }


    if (
      answers.use === 'drawing' &&
      model.familyHandle === 'ipad'
    ) {
      penalty -= 6;
    }


    if (
      answers.use === 'pro' &&
      model.familyHandle === 'ipad'
    ) {
      penalty -= 8;
    }


    return penalty;
  }



  /* ==========================================
     SCORING - PRIORITY / VALUE
     ========================================== */

  function getRelativeAffordability(
    model,
    models
  ) {
    const prices =
      models
        .map(
          function (item) {
            return Number(
              item.minPrice
            ) || 0;
          }
        )
        .filter(
          function (price) {
            return price > 0;
          }
        );


    if (!prices.length) {
      return 0;
    }


    const minPrice =
      Math.min.apply(
        null,
        prices
      );


    const maxPrice =
      Math.max.apply(
        null,
        prices
      );


    if (
      maxPrice === minPrice
    ) {
      return 1;
    }


    return (
      maxPrice -
      model.minPrice
    ) / (
      maxPrice -
      minPrice
    );
  }



  function getDiscountBonus(
    model
  ) {
    if (
      !model.compareAtPrice ||
      model.compareAtPrice <=
        model.minPrice
    ) {
      return 0;
    }


    const discount =
      (
        model.compareAtPrice -
        model.minPrice
      ) /
      model.compareAtPrice;


    return Math.min(
      1.5,
      discount * 5
    );
  }



  function getCapabilityScore(
    model
  ) {
    const scores = {
      ipad: 0,
      'ipad-mini': 1,
      'ipad-air': 3,
      'ipad-pro': 4
    };


    return (
      scores[
        model.familyHandle
      ] || 0
    );
  }



  function getPremiumScore(
    model
  ) {
    const scores = {
      ipad: 0,
      'ipad-mini': 1,
      'ipad-air': 3,
      'ipad-pro': 6
    };


    return (
      scores[
        model.familyHandle
      ] || 0
    );
  }



  function getLatestGenerationBonus(
    model,
    models
  ) {
    const comparable =
      models.filter(
        function (item) {
          return (
            item.familyHandle ===
              model.familyHandle &&
            item.sizeCategory ===
              model.sizeCategory
          );
        }
      );


    if (
      comparable.length < 2
    ) {
      return 0;
    }


    const generationNumbers =
      comparable
        .map(
          function (item) {
            return Number(
              item.generationNumber
            ) || 0;
          }
        )
        .filter(
          function (number) {
            return number > 0;
          }
        );


    if (
      generationNumbers.length < 2
    ) {
      return 0;
    }


    const newest =
      Math.max.apply(
        null,
        generationNumbers
      );


    return (
      model.generationNumber ===
      newest
    )
      ? 3
      : 0;
  }



  function getPriorityAdjustment(
    model,
    models,
    priority
  ) {
    const affordability =
      getRelativeAffordability(
        model,
        models
      );


    const discountBonus =
      getDiscountBonus(
        model
      );


    const generationBonus =
      getLatestGenerationBonus(
        model,
        models
      );


    if (
      priority === 'value'
    ) {
      return (
        affordability * 8 +
        discountBonus
      );
    }


    if (
      priority === 'balance'
    ) {
      return (
        affordability * 3.5 +
        discountBonus * 0.5
      );
    }


    if (
      priority === 'future'
    ) {
      return (
        getCapabilityScore(
          model
        ) * 0.8 +
        generationBonus
      );
    }


    if (
      priority === 'premium'
    ) {
      return (
        getPremiumScore(
          model
        ) +
        generationBonus * 0.8
      );
    }


    return 0;
  }



  /* ==========================================
     COMPLETE SCORE
     ========================================== */

  function scoreIpadModel(
    model,
    state,
    models
  ) {
    const answers =
      state.answers;


    const useScore =
      getUseScore(
        model,
        answers.use
      );


    const sizeScore =
      getSizeScore(
        model,
        answers.size
      );


    const accessoriesScore =
      getAccessoriesScore(
        model,
        answers.accessories
      );


    const intensityScore =
      getIntensityScore(
        model,
        answers.intensity
      );


    const hardPenalty =
      getHardPenalty(
        model,
        answers
      );


    const suitabilityScore =
      50 +
      useScore +
      sizeScore +
      accessoriesScore +
      intensityScore +
      hardPenalty;


    const priorityAdjustment =
      getPriorityAdjustment(
        model,
        models,
        answers.priority
      );


    const totalScore =
      suitabilityScore +
      priorityAdjustment;


    return {
      model: model,

      score:
        totalScore,

      suitabilityScore:
        suitabilityScore,

      breakdown: {
        use:
          useScore,

        size:
          sizeScore,

        accessories:
          accessoriesScore,

        intensity:
          intensityScore,

        penalty:
          hardPenalty,

        priority:
          priorityAdjustment
      }
    };
  }



  function rankIpadModels(
    models,
    state
  ) {
    return models
      .map(
        function (model) {
          return scoreIpadModel(
            model,
            state,
            models
          );
        }
      )
      .sort(
        function (a, b) {

          if (
            b.score !== a.score
          ) {
            return (
              b.score -
              a.score
            );
          }


          return (
            a.model.minPrice -
            b.model.minPrice
          );
        }
      );
  }



  /* ==========================================
     TOP 3 DIVERSITY
     ========================================== */

  function isSameFamilyAndSize(
    itemA,
    itemB
  ) {
    if (
      !itemA ||
      !itemB
    ) {
      return false;
    }


    return (
      itemA.model.familyHandle ===
        itemB.model.familyHandle &&
      itemA.model.sizeCategory ===
        itemB.model.sizeCategory
    );
  }



  function isSameFamily(
    itemA,
    itemB
  ) {
    if (
      !itemA ||
      !itemB
    ) {
      return false;
    }


    return (
      itemA.model.familyHandle ===
      itemB.model.familyHandle
    );
  }



  function hasMeaningfulTradeoff(
    best,
    candidate
  ) {
    if (
      !best ||
      !candidate
    ) {
      return false;
    }


    if (
      !isSameFamilyAndSize(
        best,
        candidate
      )
    ) {
      return false;
    }


    if (
      best.model.baseHandle ===
      candidate.model.baseHandle
    ) {
      return false;
    }


    const scoreGap =
      best.score -
      candidate.score;


    if (
      scoreGap > 6
    ) {
      return false;
    }


    const priceDifference =
      Math.abs(
        best.model.minPrice -
        candidate.model.minPrice
      );


    const generationDifference =
      best.model.generationNumber !==
      candidate.model.generationNumber;


    return (
      priceDifference >= 5000 ||
      generationDifference
    );
  }



  function getSameFamilySizeAlternative(
    ranking,
    best,
    state
  ) {
    const candidates =
      ranking.filter(
        function (item) {
          return (
            item !== best &&
            hasMeaningfulTradeoff(
              best,
              item
            )
          );
        }
      );


    if (!candidates.length) {
      return null;
    }


    if (
      state.answers.priority ===
        'value' ||
      state.answers.priority ===
        'balance'
    ) {

      const newer =
        candidates
          .filter(
            function (item) {
              return (
                item.model.generationNumber >
                best.model.generationNumber
              );
            }
          )
          .sort(
            function (a, b) {

              if (
                b.model.generationNumber !==
                a.model.generationNumber
              ) {
                return (
                  b.model.generationNumber -
                  a.model.generationNumber
                );
              }


              return (
                b.score -
                  a.score
              );
            }
          )[0];


      if (newer) {
        return newer;
      }
    }


    if (
      state.answers.priority ===
        'future' ||
      state.answers.priority ===
        'premium'
    ) {

      const cheaper =
        candidates
          .filter(
            function (item) {
              return (
                item.model.minPrice <
                best.model.minPrice
              );
            }
          )
          .sort(
            function (a, b) {

              if (
                b.score !== a.score
              ) {
                return (
                  b.score -
                  a.score
                );
              }


              return (
                a.model.minPrice -
                b.model.minPrice
              );
            }
          )[0];


      if (cheaper) {
        return cheaper;
      }
    }


    return candidates[0];
  }



  function conflictsWithSelectedGroup(
    candidate,
    selected
  ) {
    return selected.some(
      function (selectedItem) {
        return isSameFamilyAndSize(
          candidate,
          selectedItem
        );
      }
    );
  }



  function getSecondAlternative(
    ranking,
    best,
    selected
  ) {
    const unused =
      ranking.filter(
        function (item) {
          return !selected.includes(
            item
          );
        }
      );


    const differentFamily =
      unused.find(
        function (item) {
          return (
            item.model.familyHandle !==
            best.model.familyHandle
          );
        }
      );


    if (differentFamily) {
      return differentFamily;
    }


    const differentSize =
      unused.find(
        function (item) {
          return (
            item.model.sizeCategory !==
            best.model.sizeCategory
          );
        }
      );


    if (differentSize) {
      return differentSize;
    }


    return unused[0] || null;
  }



  function getThirdAlternative(
    ranking,
    selected
  ) {
    const unused =
      ranking.filter(
        function (item) {
          return !selected.includes(
            item
          );
        }
      );


    const newGroup =
      unused.find(
        function (item) {
          return !conflictsWithSelectedGroup(
            item,
            selected
          );
        }
      );


    if (newGroup) {
      return newGroup;
    }


    return unused[0] || null;
  }



  function selectDiverseTop3(
    ranking,
    state
  ) {
    if (!ranking.length) {
      return [];
    }


    const selected = [];


    const best =
      ranking[0];


    selected.push(
      best
    );


    const sameFamilyAlternative =
      getSameFamilySizeAlternative(
        ranking,
        best,
        state
      );


    if (sameFamilyAlternative) {

      selected.push(
        sameFamilyAlternative
      );

    } else {

      const second =
        getSecondAlternative(
          ranking,
          best,
          selected
        );


      if (second) {
        selected.push(
          second
        );
      }
    }


    if (
      selected.length < 3
    ) {

      const third =
        getThirdAlternative(
          ranking,
          selected
        );


      if (third) {
        selected.push(
          third
        );
      }
    }


    ranking.forEach(
      function (item) {

        if (
          selected.length >= 3
        ) {
          return;
        }


        if (
          !selected.includes(
            item
          )
        ) {
          selected.push(
            item
          );
        }

      }
    );


    return selected.slice(
      0,
      3
    );
  }



  function getTop3Role(
    item,
    index,
    top3
  ) {
    if (index === 0) {
      return 'Beste match';
    }


    const best =
      top3[0];


    if (
      isSameFamilyAndSize(
        best,
        item
      )
    ) {
      return 'Andere generatie';
    }


    if (
      isSameFamily(
        best,
        item
      ) &&
      best.model.sizeCategory !==
        item.model.sizeCategory
    ) {
      return 'Ander formaat';
    }


    return 'Ander accent';
  }



  /* ==========================================
     FINAL RESULT HELPERS
     ========================================== */

  function getModelCheapestProduct(model) {
    if (
      !model ||
      !Array.isArray(
        model.configurations
      )
    ) {
      return null;
    }


    return (
      model.configurations.find(
        function (product) {
          return (
            Number(
              product.price
            ) ===
            Number(
              model.minPrice
            )
          );
        }
      ) ||
      model.configurations[0] ||
      null
    );
  }



  function formatResultPrice(
    cents,
    isFrench
  ) {
    return new Intl.NumberFormat(
      isFrench
        ? 'fr-BE'
        : 'nl-BE',
      {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0
      }
    ).format(
      (Number(cents) || 0) /
        100
    );
  }



  function getLocalizedIpadPath(
    path,
    isFrench
  ) {
    if (!path) {
      return '#';
    }


    if (
      /^https?:\/\//i.test(
        path
      )
    ) {
      return path;
    }


    if (!isFrench) {
      return path;
    }


    if (
      path === '/fr' ||
      path.indexOf('/fr/') === 0
    ) {
      return path;
    }


    return '/fr' + path;
  }



  function getIpadResultReasons(
    item,
    state,
    isFrench
  ) {
    const model =
      item.model;


    const answers =
      state.answers;


    const reasons = [];


    const familyReasons =
      isFrench
        ? {
            ipad:
              'Un iPad polyvalent et accessible pour les tâches du quotidien, les apps et le divertissement.',

            'ipad-mini':
              'Son format compact et léger est idéal si la mobilité compte beaucoup pour vous.',

            'ipad-air':
              'Un excellent équilibre entre performances, mobilité et possibilités avec Apple Pencil et un clavier.',

            'ipad-pro':
              'Le choix le plus avancé pour les workflows créatifs et professionnels exigeants.'
          }
        : {
            ipad:
              'Een veelzijdige en toegankelijke iPad voor dagelijkse taken, apps en entertainment.',

            'ipad-mini':
              'Het compacte en lichte formaat is ideaal als je iPad vaak mee op pad gaat.',

            'ipad-air':
              'Een sterke balans tussen prestaties, draagbaarheid en mogelijkheden met Apple Pencil en toetsenbord.',

            'ipad-pro':
              'De meest geavanceerde keuze voor veeleisend creatief en professioneel gebruik.'
          };


    if (
      familyReasons[
        model.familyHandle
      ]
    ) {
      reasons.push(
        familyReasons[
          model.familyHandle
        ]
      );
    }


    if (
      answers.size === 'compact' &&
      model.sizeCategory ===
        'compact'
    ) {
      reasons.push(
        isFrench
          ? 'Il correspond à votre préférence pour un iPad aussi compact et léger que possible.'
          : 'Past bij je voorkeur voor een iPad die zo klein en licht mogelijk is.'
      );
    }


    if (
      answers.size === 'standard' &&
      model.sizeCategory ===
        'standard'
    ) {
      reasons.push(
        isFrench
          ? 'Son format offre un bon équilibre entre mobilité et espace d’affichage.'
          : 'Het formaat geeft je een goede balans tussen draagbaarheid en schermruimte.'
      );
    }


    if (
      answers.size === 'large' &&
      model.sizeCategory === 'large'
    ) {
      reasons.push(
        isFrench
          ? 'Le grand écran vous offre l’espace supplémentaire que vous recherchez.'
          : 'Het grotere scherm geeft je de extra werk- en kijkruimte die je zoekt.'
      );
    }


    if (
      answers.accessories ===
        'pencil' ||
      answers.accessories ===
        'both'
    ) {

      if (
        model.familyHandle ===
          'ipad-air' ||
        model.familyHandle ===
          'ipad-pro' ||
        model.familyHandle ===
          'ipad-mini'
      ) {
        reasons.push(
          isFrench
            ? 'Un choix particulièrement intéressant si vous comptez utiliser régulièrement Apple Pencil.'
            : 'Een sterke keuze als je Apple Pencil regelmatig wilt gebruiken.'
        );
      }
    }


    if (
      answers.accessories ===
        'keyboard' ||
      answers.accessories ===
        'both'
    ) {

      if (
        model.familyHandle ===
          'ipad-air' ||
        model.familyHandle ===
          'ipad-pro'
      ) {
        reasons.push(
          isFrench
            ? 'Il convient bien à un usage régulier avec un clavier pour rédiger et travailler.'
            : 'Past goed bij regelmatig gebruik met een toetsenbord om te typen en werken.'
        );
      }
    }


    if (
      answers.use === 'reading' &&
      model.familyHandle ===
        'ipad-mini'
    ) {
      reasons.push(
        isFrench
          ? 'Particulièrement pratique pour lire et l’emporter facilement partout.'
          : 'Bijzonder handig om te lezen en gemakkelijk overal mee naartoe te nemen.'
      );
    }


    if (
      answers.use === 'study' &&
      model.familyHandle ===
        'ipad-air'
    ) {
      reasons.push(
        isFrench
          ? 'Très polyvalent pour les cours, les notes, les recherches et le multitâche.'
          : 'Heel veelzijdig voor lessen, notities, opzoekwerk en multitasking.'
      );
    }


    if (
      answers.use === 'family' &&
      model.familyHandle === 'ipad'
    ) {
      reasons.push(
        isFrench
          ? 'Un choix simple et polyvalent pour apprendre, jouer et se divertir en famille.'
          : 'Een eenvoudige en veelzijdige keuze om te leren, spelen en ontspannen met het gezin.'
      );
    }


    if (
      answers.use === 'drawing' &&
      (
        model.familyHandle ===
          'ipad-air' ||
        model.familyHandle ===
          'ipad-pro'
      )
    ) {
      reasons.push(
        isFrench
          ? 'Bien adapté au dessin, à l’illustration et aux projets créatifs.'
          : 'Goed geschikt voor tekenen, illustreren en andere creatieve projecten.'
      );
    }


    if (
      answers.use === 'creative' &&
      (
        model.familyHandle ===
          'ipad-air' ||
        model.familyHandle ===
          'ipad-pro'
      )
    ) {
      reasons.push(
        isFrench
          ? 'Les performances correspondent bien à des projets photo, vidéo et graphiques plus exigeants.'
          : 'De prestaties sluiten goed aan bij zwaardere foto-, video- en grafische projecten.'
      );
    }


    if (
      answers.use === 'work' &&
      (
        model.familyHandle ===
          'ipad-air' ||
        model.familyHandle ===
          'ipad-pro'
      )
    ) {
      reasons.push(
        isFrench
          ? 'Un choix solide pour le multitâche, les documents et un usage professionnel régulier.'
          : 'Een sterke keuze voor multitasking, documenten en regelmatig professioneel gebruik.'
      );
    }


    if (
      answers.use === 'pro' &&
      model.familyHandle ===
        'ipad-pro'
    ) {
      reasons.push(
        isFrench
          ? 'Il correspond à votre priorité donnée aux performances pour un usage professionnel intensif.'
          : 'Sluit aan bij je focus op prestaties voor intensief professioneel gebruik.'
      );
    }


    if (
      answers.priority === 'value'
    ) {
      reasons.push(
        isFrench
          ? 'Son prix et ses possibilités en font un choix intéressant pour votre profil.'
          : 'De prijs en mogelijkheden vormen een sterke combinatie voor jouw profiel.'
      );
    }


    if (
      answers.priority ===
        'balance'
    ) {
      reasons.push(
        isFrench
          ? 'Il offre un équilibre convaincant entre prix, performances et possibilités.'
          : 'Biedt een sterke balans tussen prijs, prestaties en mogelijkheden.'
      );
    }


    if (
      answers.priority === 'future' &&
      (
        model.familyHandle ===
          'ipad-air' ||
        model.familyHandle ===
          'ipad-pro'
      )
    ) {
      reasons.push(
        isFrench
          ? 'Il vous laisse davantage de marge pour des usages plus exigeants dans les années à venir.'
          : 'Geeft je extra marge voor zwaardere toepassingen in de komende jaren.'
      );
    }


    if (
      answers.priority ===
        'premium' &&
      model.familyHandle ===
        'ipad-pro'
    ) {
      reasons.push(
        isFrench
          ? 'Il correspond à votre préférence pour l’expérience iPad la plus complète.'
          : 'Sluit aan bij je voorkeur voor de meest complete iPad-ervaring.'
      );
    }


    return Array.from(
      new Set(
        reasons
      )
    ).slice(
      0,
      3
    );
  }



  function getIpadBenefitIcon(type) {
    const icons = {

      warranty: `
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M12 3 19 6v5c0 4.6-2.9 8-7 10-4.1-2-7-5.4-7-10V6l7-3Z"/>
          <path d="m9 12 2 2 4-4"/>
        </svg>
      `,


      setup: `
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <rect
            x="6"
            y="3"
            width="12"
            height="18"
            rx="2"
          />
          <path d="M10 17h4"/>
          <path d="m9 9 2 2 4-4"/>
        </svg>
      `,


      tradein: `
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M7 7h10"/>
          <path d="m14 4 3 3-3 3"/>
          <path d="M17 17H7"/>
          <path d="m10 20-3-3 3-3"/>
        </svg>
      `,


      financing: `
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <rect
            x="3"
            y="5"
            width="18"
            height="14"
            rx="2"
          />
          <path d="M3 9h18"/>
          <path d="M7 15h4"/>
        </svg>
      `

    };


    return `
      <span
        class="lab9-ipad-choice-helper__benefit-icon"
      >
        ${icons[type] || ''}
      </span>
    `;
  }



  function getIpadStoreAdviceConfig(
    section,
    isFrench
  ) {
    const sectionId =
      section.dataset.sectionId;


    const element =
      section.querySelector(
        '[data-ipad-store-advice="' +
          sectionId +
          '"]'
      ) ||
      document.querySelector(
        '[data-ipad-store-advice="' +
          sectionId +
          '"]'
      );


    let config = {
      image: '',
      link: ''
    };


    if (element) {

      try {
        config =
          JSON.parse(
            element.textContent
          );

      } catch (error) {

        console.error(
          '[Lab9 iPad keuzehulp] Winkeladvies kon niet worden gelezen:',
          error
        );

      }
    }


    return {
      image:
        config.image || '',

      link:
        config.link ||
        (
          isFrench
            ? '/fr/pages/magasins-store-locator'
            : '/pages/winkels-store-locator'
        )
    };
  }



  function buildEnergyRatingHtml(
    product,
    modalId,
    isFrench
  ) {
    if (
      !product ||
      !product.energyArrowImage
    ) {
      return '';
    }


    const energyTitle =
      isFrench
        ? 'Étiquette énergétique'
        : 'Energielabel';


    const sheetLabel =
      isFrench
        ? 'Fiche d’information sur le produit'
        : 'Productinformatieblad';


    const popupImage =
      product.energyPopupImage
        ? `
          <img
            class="energy-rating__popup-image"
            src="${escapeHtml(
              product.energyPopupImage
            )}"
            alt="${escapeHtml(
              product.energyArrowAlt ||
              energyTitle
            )}"
            width="408"
            height="815"
            loading="lazy"
          >
        `
        : '';


    const specImage =
      product.energyPopupSpecImage
        ? `
          <img
            class="energy-rating__popup-image"
            src="${escapeHtml(
              product.energyPopupSpecImage
            )}"
            alt=""
            width="408"
            height="815"
            loading="lazy"
          >
        `
        : '';


    const sheetLink =
      product.energySheetUrl
        ? `
          <a
            class="
              energy-rating__trigger
              js-energy-rating-wrapped-item
            "
            href="${escapeHtml(
              product.energySheetUrl
            )}"
            target="_blank"
            rel="noopener"
          >
            <span class="underlined-text">
              ${escapeHtml(
                sheetLabel
              )}
            </span>
          </a>
        `
        : '';


    return `
      <energy-rating
        class="
          energy-rating
          js-energy-rating
          lab9-ipad-choice-helper__energy-rating
        "
      >

        <span class="energy-rating__container">

          <span
            class="
              energy-rating__actions
              js-energy-rating-actions
            "
          >

            <span class="energy-rating__text">

              <span class="seedkit-component-standalone">

                <a
                  class="
                    ac-modal-trigger
                    icon
                    lab9-ipad-choice-helper__energy-trigger
                  "
                  data-modal-target="modal-${escapeHtml(
                    modalId
                  )}"
                  title="${escapeHtml(
                    energyTitle
                  )}"
                  aria-label="${escapeHtml(
                    energyTitle
                  )}"
                  tabindex="0"
                >

                  <span class="underlined-text">

                    <span
                      class="
                        energy-rating__image
                        lab9-ipad-choice-helper__energy-image
                      "
                    >
                      <img
                        src="${escapeHtml(
                          product.energyArrowImage
                        )}"
                        alt="${escapeHtml(
                          product.energyArrowAlt ||
                          energyTitle
                        )}"
                        loading="lazy"
                      >
                    </span>

                  </span>

                </a>


                <div
                  id="modal-${escapeHtml(
                    modalId
                  )}"
                  class="ac-modal"
                  data-type="content"
                  data-width="wide"
                  data-variant="pageOverlay"
                  data-modal-dialog-label="${escapeHtml(
                    energyTitle
                  )}"
                  data-modal-close-label="Close Modal"
                  data-ipad-result-modal
                >

                  <h2 class="energy-rating__heading">
                    ${escapeHtml(
                      energyTitle
                    )}
                  </h2>

                  ${popupImage}

                  ${specImage}

                  ${sheetLink}

                </div>

              </span>

            </span>

          </span>

        </span>

      </energy-rating>
    `;
  }



  function refreshIpadResultModals() {
    if (
      typeof window.refreshModals ===
      'function'
    ) {
      window.refreshModals();

      return;
    }


    window.setTimeout(
      function () {

        if (
          typeof window.refreshModals ===
          'function'
        ) {
          window.refreshModals();
        }

      },
      250
    );
  }



  /* ==========================================
     FINAL RESULTS

     Zelfde visuele hiërarchie als de
     Mac-keuzehulp:

     1 grote Beste match
     + 2 alternatieven
     + Lab9 voordelen
     + winkeladvies
     ========================================== */

  function renderFinalResults(
    context
  ) {
    const section =
      context.section;


    const state =
      context.state;


    const mount =
      context.mount;


    const models =
      context.models;


    const isFrench =
      isFrenchLocale(
        section
      );


    const ranking =
      rankIpadModels(
        models,
        state
      );


    const top3 =
      selectDiverseTop3(
        ranking,
        state
      );


    const storeAdvice =
      getIpadStoreAdviceConfig(
        section,
        isFrench
      );


    const labels =
      isFrench
        ? {
            eyebrow:
              'Votre recommandation',

            title:
              'Les iPad qui vous correspondent le mieux',

            intro:
              'Sur la base de vos réponses, voici nos recommandations. Le premier choix correspond le mieux à votre profil, tandis que les alternatives mettent l’accent sur d’autres priorités.',

            best:
              'Meilleur choix',

            alternative:
              'Alternative',

            from:
              'À partir de',

            why:
              'Pourquoi ce choix ?',

            view:
              'Voir les modèles',

            edit:
              'Modifier mes réponses',

            restart:
              'Recommencer',

            lab9Eyebrow:
              'Lab9. Vous êtes au bon endroit.',

            lab9Title:
              'Bien plus que le bon iPad.',

            lab9Intro:
              'Chez Lab9, vous bénéficiez aussi de services qui vous accompagnent avant et après votre achat.',

            warranty:
              '3 ans de garantie sur iPad',

            warrantyText:
              'Pour les clients particuliers.',

            setup:
              'Personal Setup & Support',

            setupText:
              'Une aide personnalisée pour configurer et utiliser votre iPad.',

            tradein:
              'Trade-in',

            tradeinText:
              'Faites reprendre votre ancien appareil.',

            financing:
              'Financement',

            financingText:
              'Étalez le paiement de votre achat.',

            discover:
              'En savoir plus',

            storeEyebrow:
              'Conseils personnalisés en magasin',

            storeTitle:
              'Vous hésitez encore ?',

            storeText:
              'Passez dans un magasin Lab9. Nos experts Apple prennent le temps de comprendre vos besoins et vous aident à choisir l’iPad qui vous convient.',

            storeButton:
              'Trouver un magasin'
          }
        : {
            eyebrow:
              'Jouw advies',

            title:
              'Deze iPads passen het best bij jou',

            intro:
              'Op basis van je antwoorden raden we deze modellen aan. De eerste keuze sluit het sterkst aan bij je profiel, terwijl de alternatieven andere accenten leggen.',

            best:
              'Beste match',

            alternative:
              'Alternatief',

            from:
              'Vanaf',

            why:
              'Waarom deze past',

            view:
              'Bekijk de modellen',

            edit:
              'Antwoorden aanpassen',

            restart:
              'Opnieuw beginnen',

            lab9Eyebrow:
              'Lab9. Hier zit je goed.',

            lab9Title:
              'Meer dan alleen de juiste iPad.',

            lab9Intro:
              'Bij Lab9 krijg je ook diensten die je voor en na je aankoop verder helpen.',

            warranty:
              '3 jaar garantie op iPad',

            warrantyText:
              'Voor particuliere klanten.',

            setup:
              'Personal Setup & Support',

            setupText:
              'Persoonlijke hulp bij het instellen en gebruiken van je iPad.',

            tradein:
              'Trade-in',

            tradeinText:
              'Ruil je oude toestel in.',

            financing:
              'Financiering',

            financingText:
              'Spreid de betaling van je aankoop.',

            discover:
              'Meer info',

            storeEyebrow:
              'Persoonlijk advies in de winkel',

            storeTitle:
              'Nog niet helemaal zeker?',

            storeText:
              'Kom langs bij een Lab9-winkel. Onze Apple-experts luisteren naar wat je nodig hebt en helpen je de juiste iPad kiezen.',

            storeButton:
              'Vind een winkel'
          };


    if (!top3.length) {

      mount.innerHTML =
        isFrench
          ? '<p>Aucun modèle iPad adapté n’a été trouvé.</p>'
          : '<p>Geen geschikte iPad-modellen gevonden.</p>';


      scrollIpadChoiceToTop(
        context
      );


      return;
    }


    const cards =
      top3
        .map(
          function (
            item,
            index
          ) {

            const model =
              item.model;


            const isBest =
              index === 0;


            const product =
              getModelCheapestProduct(
                model
              );


            const reasons =
              getIpadResultReasons(
                item,
                state,
                isFrench
              );


            const reasonsHtml =
              reasons
                .map(
                  function (reason) {
                    return `
                      <li>
                        ${escapeHtml(
                          reason
                        )}
                      </li>
                    `;
                  }
                )
                .join('');


            const modelUrl =
              getLocalizedIpadPath(
                model.familyUrl,
                isFrench
              );


            const image =
              model.image
                ? `
                  <img
                    src="${escapeHtml(
                      model.image
                    )}"
                    alt="${escapeHtml(
                      model.name
                    )}"
                    loading="lazy"
                  >
                `
                : '';


            const modalId =
              'ipad-choice-' +
              String(
                section.dataset.sectionId ||
                'section'
              ) +
              '-' +
              String(
                index + 1
              );


            const energyHtml =
              buildEnergyRatingHtml(
                product,
                modalId,
                isFrench
              );


            return `
              <article
                class="
                  lab9-ipad-choice-helper__result-card
                  ${
                    isBest
                      ? 'lab9-ipad-choice-helper__result-card--best'
                      : ''
                  }
                "
              >

                <div
                  class="lab9-ipad-choice-helper__result-visual"
                >
                  ${image}
                </div>


                <div
                  class="lab9-ipad-choice-helper__result-body"
                >

                  <div
                    class="lab9-ipad-choice-helper__result-badge"
                  >
                    ${
                      isBest
                        ? escapeHtml(
                            labels.best
                          )
                        : escapeHtml(
                            labels.alternative
                          )
                    }
                  </div>


                  <h3
                    class="lab9-ipad-choice-helper__result-name"
                  >
                    ${escapeHtml(
                      model.name
                    )}
                  </h3>


                  <div
                    class="lab9-ipad-choice-helper__result-price-row"
                  >

                    <p
                      class="lab9-ipad-choice-helper__result-price"
                    >
                      ${escapeHtml(
                        labels.from
                      )}

                      <strong>
                        ${escapeHtml(
                          formatResultPrice(
                            model.minPrice,
                            isFrench
                          )
                        )}
                      </strong>
                    </p>


                    ${energyHtml}

                  </div>


                  <div
                    class="lab9-ipad-choice-helper__result-reasons"
                  >

                    <strong>
                      ${escapeHtml(
                        labels.why
                      )}
                    </strong>

                    <ul>
                      ${reasonsHtml}
                    </ul>

                  </div>


                  <div
                    class="lab9-ipad-choice-helper__result-actions"
                  >

                    <a
                      href="${escapeHtml(
                        modelUrl
                      )}"
                      class="lab9-ipad-choice-helper__result-button"
                    >
                      ${escapeHtml(
                        labels.view
                      )}
                    </a>

                  </div>

                </div>

              </article>
            `;
          }
        )
        .join('');


    const warrantyUrl =
      isFrench
        ? '/fr/pages/garantie-de-3-ans'
        : '/pages/3-jaar-garantie';


    const setupUrl =
      isFrench
        ? '/fr/pages/personal-setup-support'
        : '/pages/personal-setup-support';


    const tradeInUrl =
      isFrench
        ? '/fr/pages/trade-in'
        : '/pages/trade-in';


    const financingUrl =
      isFrench
        ? '/fr/pages/financement'
        : '/pages/financiering';


    const storeImageHtml =
      storeAdvice.image
        ? `
          <div
            class="lab9-ipad-choice-helper__store-advice-media"
          >
            <img
              src="${escapeHtml(
                storeAdvice.image
              )}"
              alt="${escapeHtml(
                labels.storeTitle
              )}"
              loading="lazy"
            >
          </div>
        `
        : '';


    mount.innerHTML = `
      <div
        class="lab9-ipad-choice-helper__results"
      >

        <header
          class="lab9-ipad-choice-helper__results-header"
        >

          <p
            class="lab9-ipad-choice-helper__eyebrow"
          >
            ${escapeHtml(
              labels.eyebrow
            )}
          </p>


          <h2>
            ${escapeHtml(
              labels.title
            )}
          </h2>


          <p>
            ${escapeHtml(
              labels.intro
            )}
          </p>

        </header>


        <div
          class="lab9-ipad-choice-helper__results-grid"
        >
          ${cards}
        </div>


        <div
          class="lab9-ipad-choice-helper__result-navigation"
        >

          <button
            type="button"
            class="
              lab9-ipad-choice-helper__result-button
              lab9-ipad-choice-helper__result-button--secondary
            "
            data-ipad-result-edit
          >
            ${escapeHtml(
              labels.edit
            )}
          </button>


          <button
            type="button"
            class="
              lab9-ipad-choice-helper__result-button
              lab9-ipad-choice-helper__result-button--secondary
            "
            data-ipad-result-restart
          >
            ${escapeHtml(
              labels.restart
            )}
          </button>

        </div>


        <section
          class="lab9-ipad-choice-helper__benefits"
        >

          <div
            class="lab9-ipad-choice-helper__benefits-header"
          >

            <p
              class="lab9-ipad-choice-helper__eyebrow"
            >
              ${escapeHtml(
                labels.lab9Eyebrow
              )}
            </p>


            <h2>
              ${escapeHtml(
                labels.lab9Title
              )}
            </h2>


            <p>
              ${escapeHtml(
                labels.lab9Intro
              )}
            </p>

          </div>


          <div
            class="lab9-ipad-choice-helper__benefits-grid"
          >

            <a
              href="${escapeHtml(
                warrantyUrl
              )}"
              class="lab9-ipad-choice-helper__benefit"
            >

              ${getIpadBenefitIcon(
                'warranty'
              )}


              <strong>
                ${escapeHtml(
                  labels.warranty
                )}
              </strong>


              <span>
                ${escapeHtml(
                  labels.warrantyText
                )}
              </span>


              <small>
                ${escapeHtml(
                  labels.discover
                )} →
              </small>

            </a>


            <a
              href="${escapeHtml(
                setupUrl
              )}"
              class="lab9-ipad-choice-helper__benefit"
            >

              ${getIpadBenefitIcon(
                'setup'
              )}


              <strong>
                ${escapeHtml(
                  labels.setup
                )}
              </strong>


              <span>
                ${escapeHtml(
                  labels.setupText
                )}
              </span>


              <small>
                ${escapeHtml(
                  labels.discover
                )} →
              </small>

            </a>


            <a
              href="${escapeHtml(
                tradeInUrl
              )}"
              class="lab9-ipad-choice-helper__benefit"
            >

              ${getIpadBenefitIcon(
                'tradein'
              )}


              <strong>
                ${escapeHtml(
                  labels.tradein
                )}
              </strong>


              <span>
                ${escapeHtml(
                  labels.tradeinText
                )}
              </span>


              <small>
                ${escapeHtml(
                  labels.discover
                )} →
              </small>

            </a>


            <a
              href="${escapeHtml(
                financingUrl
              )}"
              class="lab9-ipad-choice-helper__benefit"
            >

              ${getIpadBenefitIcon(
                'financing'
              )}


              <strong>
                ${escapeHtml(
                  labels.financing
                )}
              </strong>


              <span>
                ${escapeHtml(
                  labels.financingText
                )}
              </span>


              <small>
                ${escapeHtml(
                  labels.discover
                )} →
              </small>

            </a>

          </div>

        </section>


        <section
          class="lab9-ipad-choice-helper__store-advice"
        >

          <div
            class="lab9-ipad-choice-helper__store-advice-copy"
          >

            <p
              class="lab9-ipad-choice-helper__eyebrow"
            >
              ${escapeHtml(
                labels.storeEyebrow
              )}
            </p>


            <h2>
              ${escapeHtml(
                labels.storeTitle
              )}
            </h2>


            <p>
              ${escapeHtml(
                labels.storeText
              )}
            </p>


            <a
              href="${escapeHtml(
                storeAdvice.link
              )}"
              class="lab9-ipad-choice-helper__result-button"
            >
              ${escapeHtml(
                labels.storeButton
              )}
            </a>

          </div>


          ${storeImageHtml}

        </section>

      </div>
    `;


    const editButton =
      mount.querySelector(
        '[data-ipad-result-edit]'
      );


    if (editButton) {

      editButton.addEventListener(
        'click',
        function () {

          const questionKeys =
            getQuestionKeys(
              state
            );


          state.step =
            Math.max(
              0,
              questionKeys.length - 1
            );


          renderIpadQuestion(
            context
          );


          scrollIpadChoiceToTop(
            context
          );

        }
      );

    }


    const restartButton =
      mount.querySelector(
        '[data-ipad-result-restart]'
      );


    if (restartButton) {

      restartButton.addEventListener(
        'click',
        function () {

          state.step = 0;


          state.answers = {
            use: '',
            size: '',
            accessories: '',
            intensity: '',
            priority: ''
          };


          mount.hidden = true;
          mount.innerHTML = '';


          context.welcome.hidden =
            false;


          scrollIpadChoiceToTop(
            context
          );

        }
      );

    }


    refreshIpadResultModals();


    console.table(
      top3.map(
        function (
          item,
          index
        ) {

          const product =
            getModelCheapestProduct(
              item.model
            );


          return {
            rank:
              index + 1,

            role:
              getTop3Role(
                item,
                index,
                top3
              ),

            model:
              item.model.name,

            score:
              Number(
                item.score.toFixed(
                  1
                )
              ),

            price:
              item.model.minPrice /
              100,

            energy:
              Boolean(
                product &&
                product.energyArrowImage
              )
          };

        }
      )
    );


    scrollIpadChoiceToTop(
      context
    );
  }



  /* ==========================================
     QUESTION RENDERING
     ========================================== */

  function renderIpadQuestion(
    context
  ) {
    const copy =
      context.copy;


    const state =
      context.state;


    const mount =
      context.mount;


    cleanConditionalAnswers(
      state
    );


    const questionKeys =
      getQuestionKeys(
        state
      );


    if (
      state.step >
      questionKeys.length - 1
    ) {
      state.step =
        questionKeys.length - 1;
    }


    const questionKey =
      questionKeys[
        state.step
      ];


    const question =
      copy.questions[
        questionKey
      ];


    if (!question) {

      console.error(
        '[Lab9 iPad keuzehulp] Vraag niet gevonden:',
        questionKey
      );


      return;
    }


    const selectedValue =
      state.answers[
        questionKey
      ] || '';


    const progressHtml =
      questionKeys
        .map(
          function (_, index) {
            return `
              <span
                class="${
                  index <= state.step
                    ? 'is-active'
                    : ''
                }"
              ></span>
            `;
          }
        )
        .join('');


    const optionsHtml =
      question.options
        .map(
          function (option) {

            const isSelected =
              option.value ===
              selectedValue;


            return `
              <button
                type="button"
                class="lab9-ipad-choice-helper__answer${
                  isSelected
                    ? ' is-selected'
                    : ''
                }"
                data-ipad-answer="${escapeHtml(
                  option.value
                )}"
                aria-pressed="${
                  isSelected
                    ? 'true'
                    : 'false'
                }"
              >

                <strong>
                  ${escapeHtml(
                    option.title
                  )}
                </strong>

                <span>
                  ${escapeHtml(
                    option.text
                  )}
                </span>

              </button>
            `;
          }
        )
        .join('');


    const previousButton =
      state.step > 0
        ? `
          <button
            type="button"
            data-ipad-choice-previous
          >
            ${escapeHtml(
              copy.labels.previous
            )}
          </button>
        `
        : '';


    const isLastQuestion =
      state.step ===
      questionKeys.length - 1;


    const resultLabel =
      isFrenchLocale(
        context.section
      )
        ? 'Voir mon conseil'
        : 'Bekijk mijn advies';


    const nextButton = `
      <button
        type="button"
        data-ipad-choice-next
        ${
          selectedValue
            ? ''
            : 'disabled'
        }
      >
        ${
          isLastQuestion
            ? escapeHtml(
                resultLabel
              )
            : escapeHtml(
                copy.labels.next
              )
        }
      </button>
    `;


    mount.innerHTML = `

      <div
        class="lab9-ipad-choice-helper__question"
      >

        <div
          class="lab9-ipad-choice-helper__progress"
          aria-hidden="true"
        >
          ${progressHtml}
        </div>


        <div
          class="lab9-ipad-choice-helper__question-header"
        >

          <p
            class="lab9-ipad-choice-helper__question-count"
          >
            ${escapeHtml(
              copy.labels.question
            )}
            ${state.step + 1}
            ${escapeHtml(
              copy.labels.of
            )}
            ${questionKeys.length}
          </p>


          <h2>
            ${escapeHtml(
              question.title
            )}
          </h2>


          <p>
            ${escapeHtml(
              question.help
            )}
          </p>

        </div>


        <div
          class="lab9-ipad-choice-helper__answers"
        >
          ${optionsHtml}
        </div>


        <div
          class="lab9-ipad-choice-helper__navigation"
        >

          ${previousButton}

          ${nextButton}

        </div>

      </div>
    `;


    mount
      .querySelectorAll(
        '[data-ipad-answer]'
      )
      .forEach(
        function (button) {

          button.addEventListener(
            'click',
            function () {

              state.answers[
                questionKey
              ] =
                button.dataset
                  .ipadAnswer;


              cleanConditionalAnswers(
                state
              );


              renderIpadQuestion(
                context
              );

            }
          );

        }
      );


    const previous =
      mount.querySelector(
        '[data-ipad-choice-previous]'
      );


    if (previous) {

      previous.addEventListener(
        'click',
        function () {

          state.step =
            Math.max(
              0,
              state.step - 1
            );


          renderIpadQuestion(
            context
          );


          scrollIpadChoiceToTop(
            context
          );

        }
      );

    }


    const next =
      mount.querySelector(
        '[data-ipad-choice-next]'
      );


    if (next) {

      next.addEventListener(
        'click',
        function () {

          if (
            !state.answers[
              questionKey
            ]
          ) {
            return;
          }


          const currentQuestionKeys =
            getQuestionKeys(
              state
            );


          const currentIsLast =
            state.step ===
            currentQuestionKeys.length -
              1;


          if (currentIsLast) {

            renderFinalResults(
              context
            );


            return;
          }


          state.step += 1;


          renderIpadQuestion(
            context
          );


          scrollIpadChoiceToTop(
            context
          );

        }
      );

    }
  }



  /* ==========================================
     WIZARD INITIALIZATION
     ========================================== */

  function initializeIpadWizard(
    section,
    models
  ) {
    if (!section) {
      return;
    }


    const copy =
      getIpadChoiceCopy(
        section
      );


    if (!copy) {
      return;
    }


    const welcome =
      section.querySelector(
        '[data-ipad-choice-welcome]'
      );


    const mount =
      section.querySelector(
        '[data-ipad-choice-question-mount]'
      );


    const startButton =
      section.querySelector(
        '[data-ipad-choice-start]'
      );


    if (
      !welcome ||
      !mount ||
      !startButton
    ) {

      console.warn(
        '[Lab9 iPad keuzehulp] Wizard-elementen niet volledig gevonden.'
      );


      return;
    }


    const state = {
      step: 0,

      answers: {
        use: '',
        size: '',
        accessories: '',
        intensity: '',
        priority: ''
      }
    };


    const context = {
      section: section,
      copy: copy,
      welcome: welcome,
      mount: mount,
      models: models,
      state: state
    };


    startButton.addEventListener(
      'click',
      function () {

        welcome.hidden = true;
        mount.hidden = false;


        state.step = 0;


        state.answers = {
          use: '',
          size: '',
          accessories: '',
          intensity: '',
          priority: ''
        };


        renderIpadQuestion(
          context
        );


        scrollIpadChoiceToTop(
          context
        );

      }
    );
  }



  /* ==========================================
     INITIALIZE
     ========================================== */

  function initializeIpadChoiceHelper() {
    const section =
      document.querySelector(
        '.lab9-ipad-choice-helper'
      );


    if (!section) {
      return;
    }


    const products =
      getIpadProductFeed(
        section
      );


    const models =
      groupProductsIntoModels(
        products
      );


    console.log(
      '[Lab9 iPad keuzehulp] Shopify-configuraties:',
      products.length
    );


    console.log(
      '[Lab9 iPad keuzehulp] Logische modellen:',
      models.length
    );


    window.lab9IpadChoiceModels =
      models;


    initializeIpadWizard(
      section,
      models
    );
  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeIpadChoiceHelper
    );

  } else {

    initializeIpadChoiceHelper();

  }

})();